var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('submenu-page',{attrs:{"eyebrow":"STUDENT SERVICES","title":"Career and Guidance","description":"Support student career planning with counselling, internships and job opportunities.","count-label":"career tools"}},[_c('SubMenu')],1)}
var staticRenderFns = []

export { render, staticRenderFns }